// extracted by mini-css-extract-plugin
export var footer = "_p6-0";
export var inherit = "_p6-1";
export var input = "_p6-2";
export var modalContent = "_p6-3";
export var quillEditor = "_p6-4";
export var subtitle = "_p6-5";